import { type ReactNode } from 'react';
import CountiesPage from './counties/counties.page';
import AgenciesPage from './agencies/agencies.page';
import { Flex } from 'antd';

const OrganizationsPage = (): ReactNode => {
  return (
    <Flex vertical gap="large">
      {/* <CountiesPage /> */}
      <AgenciesPage />
    </Flex>
  );
};

OrganizationsPage.displayName = 'OrganizationsPage';
export default OrganizationsPage;
